export default {"src":"/_next/static/media/spa.2a39bb14.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};